
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcCompassSector as ObcCompassSectorElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/compass-sector/compass-sector.js';
 
 
 

 
 export const ObcCompassSector = createComponent({
   react: React,
   tagName: 'obc-compass-sector',
   elementClass: ObcCompassSectorElement,
   events: {
     
     onNone: 'None' as EventName<CustomEvent<unknown>>,
   }
  });
 
 